import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { ICourseRelevantExecutionQuery } from '../interfaces/course-relevant-execution.query.interface';
import { ModuleKind } from 'app/library/module/enums/module-kind.enum';
import { ModuleType } from 'app/library/module/enums/moduleType.enum';
import { UserProfilePicture } from 'app/projects/user/src/lib/models/user-profile-picture.model';
import { RelevantExecutionSelectionStatus } from './relevant-execution-selection-status.model';

// @dynamic
export class CourseRelevantExecution {
    static props_to_search = ['name'];

    id: string;
    name: string;
    participantCount: number;
    startDate: Date;
    endDate: Date;
    image: UserProfilePicture;
    status: string;
    version: string;
    isDefault: boolean;
    private: boolean;
    kind: ModuleKind;
    type: ModuleType;
    isManager: boolean;
    isSelected?: boolean;
    isAlreadySelected?: boolean;
    selfPaced: boolean;
    selectionStatus?: RelevantExecutionSelectionStatus;

    constructor(query: ICourseRelevantExecutionQuery) {
        this.id = query.id.toString();
        this.name = query.name;
        this.participantCount = query.participant_count;
        this.startDate = query.start_date;
        this.endDate = query.end_date;
        this.image = query.image ? new UserProfilePicture(query.image) : null;
        this.status = query.status;
        this.version = query.version;
        this.isDefault = query.is_default;
        this.kind = query.kind;
        this.type = query.type;
        this.private = query.private;
        this.selfPaced = query.self_paced;
        this.isManager = !!query.is_manager;
        this.selectionStatus = query.selection_status ? new RelevantExecutionSelectionStatus(query.selection_status) : null;
    }
}
